import Text, { TextProps } from 'components/shared/Text'
import React from 'react'
import { ResponsiveSpace } from 'styles/spacing'
import { Color } from 'styles/types'
import { InlineTextListSeparator } from './style'

interface InlineTextListProps extends TextProps {
    items: string[]
    dotColor?: Color
    hasNoWrapItems?: boolean
    gap?: ResponsiveSpace
}

const InlineTextList = ({
    items,
    variant,
    color,
    dotColor = 'primary_500',
    hasNoWrapItems = false,
    gap = 8,
}: InlineTextListProps) => (
    <Text variant="body">
        {items.map((item, index) => (
            <React.Fragment key={index}>
                {index > 0 && (
                    <InlineTextListSeparator
                        variant="heading4"
                        color={dotColor}
                        as="span"
                        mr={gap}
                    >
                        •
                    </InlineTextListSeparator>
                )}
                <Text
                    variant={variant}
                    color={color}
                    as="span"
                    mr={index < items.length - 1 ? gap : 0}
                    hasNoWrap={hasNoWrapItems}
                >
                    {item}
                </Text>
            </React.Fragment>
        ))}
    </Text>
)

export default InlineTextList
